import React from 'react';
import { Box, Container, Grid } from '@mui/material';

const Footer = () => {
    return (
        <Box pt={1} px={1} mt={1}>
            <Box component='footer'>
                <Container>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sx={{ textAlign: 'center', my: 1 }}>
                            copyright
                        </Grid>
                    </Grid>
                </Container>
            </Box>
        </Box>
    );
};

export default Footer;
